import * as Yup from 'yup'
import { reverseShape } from 'Components/shared/helpers/reverse-shape'
import { validString, date, surcharge, dateRange } from 'Components/shared/helpers/validations'

export const ServiceTypeCreateSchema = Yup.object().shape(reverseShape({
    settingID: validString.optional(),
    name: validString.required(),
    surcharge: surcharge,
    validFrom: date.required(),
    validTo: date.required().concat(dateRange)
}))